import { ComponentType, ReactElement } from 'react'
import { AspenPermissions } from './utils'

export enum AspenRoutes {
    HOME = '',
    DASHBOARD = 'dashboard',
    NOTFOUND = '404',
    CANDIDATES = 'candidates',
    PATIENTS = 'patients',
    CAREPARTNERS = 'carepartners',
    PROVIDERS = 'providers',
    REQUESTS = 'requests',
    TASKS = 'tasks',
    SNOWFLAKE = 'snowflake',
    GREENLIGHT = 'greenlight',
    ACCESS_DENIED = '403'
}

export type AspenRoute = {
    route: string
    component: ComponentType<any>
    permissions: AspenPermissions[]
    name?: ReactElement<any, any>
    icon?: ReactElement<any, any>
    exact?: boolean
}

export function toRoutingConfigObject<T extends { route: string }>(
    routes: T[],
    matchPathValue: string,
    matchUrlValue: string
): (T & { url: string; matchRoute: { path: string } })[] {
    return routes.map((routeRecord) => {
        const routeProps = { path: `${matchPathValue}/${routeRecord.route}` }
        const url = `${matchUrlValue}/${routeRecord.route}`
        return { matchRoute: routeProps, url, ...routeRecord }
    })
}
